import * as React from 'react';
import {connect} from 'react-redux';

import type {NutshellState} from '../../../store';

import * as actions from './activity-report-actions';
import {ActivityReportLegacyTab} from './activity-report-legacy-tab';
import * as selectors from './activity-report-selectors';

type StateProps = {
    isLoading: boolean;
    content: string | null | undefined;
    hasError: boolean;
    totalPages: number;
};
type DispatchProps = {
    fetchContent: (filters: any, page: number, abortController?: AbortController) => any;
};
type OwnProps = {
    onParamPush: (arg1: any, arg2: boolean) => any;
    selectedPage: number;
    stickyHeaderTop: number | null | undefined;
    filters: {
        [filter: string]: string;
    };
};
type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        isLoading: selectors.getActivitiesIsLoading(state),
        content: selectors.getActivitiesContent(state),
        hasError: selectors.getActivitiesHasError(state),
        totalPages: selectors.getActivitiesNumPages(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchContent: (filters, page, abortController) => {
            dispatch(actions.fetchActivityReportActivities(filters, page, abortController));
        },
    };
}

function ActivityReportActivitiesComponent(props: Props) {
    const {fetchContent, ...restProps} = props;

    // Track the current abort controller to cancel previous requests
    const currentAbortController = React.useRef<AbortController | null | undefined>(null);

    const fetchContentWithAbort = React.useCallback(
        (filters: any, page: number) => {
            // Abort previous request if one is in progress
            if (currentAbortController.current) {
                currentAbortController.current.abort();
            }

            // Create new abort controller for this request
            currentAbortController.current = new AbortController();

            // Create a wrapped action that includes the abort controller
            fetchContent(filters, page, currentAbortController.current);
        },
        [fetchContent]
    );

    // Cleanup on unmount
    React.useEffect(() => {
        return () => {
            if (currentAbortController.current) {
                currentAbortController.current.abort();
            }
        };
    }, []);

    return <ActivityReportLegacyTab {...restProps} fetchContent={fetchContentWithAbort} />;
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const ActivityReportActivities = connector(ActivityReportActivitiesComponent);
